/* Client mirror of RecaptchaType in ProgramForms.cs */
export const RECAPTCHA_TYPE = {
    Disable: 0,
    Full: 1,
    Minimal: 2
};

/* Parallels PC2.Common.BusinessLogic.PVProduction.PVEstimationLocationType */
export const PV_LOCATION_TYPE = {
    ZipCode: 0,
    Reference: 1,
    Geocoordinate: 2
};

export const PV_DEPENDENCY_LABELS = {
    ZipCode: "zipcode",
    Latitude: "latitude", // obsolete
    Longitude: "longitude", // obsolete
    Geolocation: "geolocation"
};

/* client mirror of PVSystemField in PVSystemElementDataField.cs */
export const PV_SYSTEM_FIELDS = {
    InverterQuantity: "InverterQuantity",
    InverterManufacturer: "InverterManufacturer",
    InverterModel: "InverterModel",
    PVModuleQuantity: "PVModuleQuantity",
    PVModuleManufacturer: "PVModuleManufacturer",
    PVModuleModel: "PVModuleModel",
    PVModuleAssignedInverter: "PVModuleAssignedInverter",
    Tilt: "Tilt",
    Azimuth: "Azimuth",
    Tracking: "Tracking",
    AzimuthalShading: "AzimuthalShading",
    MonthlyShading: "MonthlyShading",
    BatteryQuantity: "BatteryQuantity",
    BatteryManufacturer: "BatteryManufacturer",
    BatteryModel: "BatteryModel",
    BatteryAssignedInverter: "BatteryAssignedInverter",
    BatteryEquipmentType: "BatteryEquipmentType",
    BatteryEnergyRating: "BatteryEnergyRating",
    BatteryTechnology: "BatteryTechnology",
    NameplateRating: "NameplateRating",
    CECRating: "CECRating",
    CSIRating: "CSIRating",
    EstimatedProduction: "EstimatedProduction",
    DesignFactor: "DesignFactor",
    InverterNameplateRating: "InverterNameplateRating",
    PVConfiguration: "PVConfiguration",
    AverageInverterEfficiency: "AverageInverterEfficiency",
    PTCModuleRating: "PTCModuleRating",
    MonthlyEstimatedProduction: "MonthlyEstimatedProduction",
    HasAllSmartInverters: "HasAllSmartInverters",
    SystemInverterStandardValue: "SystemInverterStandardValue",
    TotalNameplateEnergyCapacity: "TotalNameplateEnergyCapacity",
    PVArrayDescription: "PVArrayDescription",
    BatteryMaximumContinuousDischargeRate: "BatteryMaximumContinuousDischargeRate",
    BatteryUsableEnergyCapacity: "BatteryUsableEnergyCapacity"
};

export const PV_SHOW_STORAGE_EQUIPMENT_OPTION_VALUE = {
    never: 0,
    always: -1,
    formula: 1
};
